import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ClientTxnCategoryListUI from './ClientTxnCategoryListUI.js'

class ClientTxnCategoryListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      categoryList: null,
      createMode: false,
      updateMode: false,
      selectedCategory: null,
      categoryValueList: null,
      codeLabelList: null,
    }
  }

  render() {
    return (
      <ClientTxnCategoryListUI
        context={this.props.context}
        errorList={this.state.errorList}

        categoryList={this.state.categoryList}
        selectedCategory={this.state.selectedCategory}
        categoryValueList={this.state.categoryValueList}
        codeLabelList={this.state.codeLabelList}

        createMode={this.state.createMode}
        updateMode={this.state.updateMode}
        category={this.props.category}
        categoryLabel={this.props.categoryLabel}
        account={this.props.account}
        // events
        onRefreshClick={this.onRefreshClick}
        onCreateClick={() => { this.setState({ createMode: true }) }}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onUpdate={this.onUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getBankAnalyzerCategories(context)
    this.getClientTxnCategories(context)
  }

  getClientTxnCategories(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/clientTxnCats`,
      cacheKey: CacheKeys.ClientTxnCategories(this.props.match.params.accountId),
      callback: this.getClientTxnCategoriesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getClientTxnCategoriesCallback = (response) => {
    this.setState({ errorList: response.errorList, categoryList: response.categoryList })
  }

  getBankAnalyzerCategories(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/bankAnalyzerCategories`,
      cacheKey: CacheKeys.BankAnalyzerCategories(this.props.match.params.accountId),
      callback: this.getBankAnalyzerCategoriesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAnalyzerCategoriesCallback = (response) => {
    let categoryValueList = response.codeLabelList.map(cat => ({ key: cat.code, value: cat.label }))
    this.setState({
      categoryValueList: categoryValueList,
      codeLabelList: response.codeLabelList,
    })
  }

  onUpdateClick = (event) => {
    let category = event.currentTarget.getAttribute('data-category')
    let selectedCategory = this.state.categoryList.filter(p => p.category === category)[0]
    this.setState({ updateMode: true, selectedCategory: selectedCategory })
  }

  onCancelClick = () => {
    this.setState({ createMode: false, updateMode: false, errorList: null })
  }

  onUpdate = (selectedCategory) => {
    CacheManager.removeObject(CacheKeys.ClientTxnCategories(this.props.match.params.accountId))
    this.setState({ categoryList: this.state.categoryList })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.ClientTxnCategories(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.BankAnalyzerCategories())
    this.getBankAnalyzerCategories(this.props.context)
    this.setState(
      {
        categoryList: null,
        errorList: null,
      },
      this.getClientTxnCategories(this.props.context)
    )
  }
}

export default withRouter(ClientTxnCategoryListSF)
